import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';


const genericStyles = {
  fontFamily: 'Schibsted Grotesk',
  fontSize: '14px',
  fontWeight: 500,
};

const BoxWrapper = styled(Box)(() =>({
  ...genericStyles,
  color: '#6D6D6D',
}));

const ButtonWrapper = styled(Button)(() =>({
  borderRadius: '6px',
  border: '1px solid #D1D1D1',
  color: '#181818',
  textTransform: 'none',
  ...genericStyles,
}));

const EllipsisWrapper = styled(Box)(() => ({
  width: '85px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  cursor: 'pointer',
}));


export {
  BoxWrapper,
  ButtonWrapper,
  EllipsisWrapper,
};